import React from "react";

export default function About({ settings }) {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-16 md:py-32 px-5 sm:px-6 md:px-12 lg:px-24 max-w-7xl mx-auto"
    >
      <div className="grid md:grid-cols-12 gap-12 items-start">
        <div className="md:col-span-5">
          <p className="overline mb-6">The Villa</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05]">
            {settings?.about_title || "A Private Sanctuary"}
          </h2>
          <div className="gold-divider mt-6 md:mt-8" />
        </div>
        <div className="md:col-span-7 md:pl-8">
          <p className="text-[#A1A4B5] leading-relaxed sm:leading-loose text-sm sm:text-base md:text-lg">
            {settings?.about_text ||
              "Nestled within tropical landscapes, our villa is a curated retreat for those who seek understated elegance, sun-drenched afternoons by the infinity pool, and starlit evenings by candlelight."}
          </p>
          <div className="mt-8 md:mt-10 grid grid-cols-3 gap-3 sm:gap-6 border-t border-[var(--border)] pt-6 md:pt-8">
            <div>
              <div className="font-serif-display text-2xl sm:text-3xl text-[#C5A059]">20</div>
              <div className="text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.2em] text-[#A1A4B5] mt-1.5 sm:mt-2">Max Guests</div>
            </div>
            <div>
              <div className="font-serif-display text-2xl sm:text-3xl text-[#C5A059]">24/7</div>
              <div className="text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.2em] text-[#A1A4B5] mt-1.5 sm:mt-2">Concierge</div>
            </div>
            <div>
              <div className="font-serif-display text-2xl sm:text-3xl text-[#C5A059]">5★</div>
              <div className="text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.2em] text-[#A1A4B5] mt-1.5 sm:mt-2">Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
